import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-linked-distributors-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
<div class="modal-backdrop" (click)="onClose()"></div>

<div class="modal">
  <div class="modal-header">
    <h2>Distributors for {{ retailerName }}</h2>
    <span class="icon-btn" (click)="onClose()">
      <i class="fas fa-times"></i>
    </span>
  </div>

  <div class="modal-body">
    <div class="search-wrap">
      <input type="text" placeholder="Search distributors..." [(ngModel)]="searchTerm" (keyup.enter)="onSearch()" />
      <button class="btn secondary" (click)="onSearch()">Search</button>
    </div>

    <div *ngIf="loading" class="state-msg">Loading distributors...</div>
    <div *ngIf="!loading && errorMsg" class="error-msg">{{errorMsg}}</div>
    
    <div *ngIf="!loading && !errorMsg && distributors.length === 0" class="state-msg">No distributors linked.</div>

    <div class="table-container" *ngIf="!loading && distributors.length > 0">
      <table class="data-table">
        <thead>
          <tr>
            <th>Distributor Name</th>
            <th>Email</th>
            <th>Customer Code</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let d of distributors">
            <td>{{ d.distributor?.distributor_name || 'Unknown' }}</td>
            <td>{{ d.distributor?.email || 'N/A' }}</td>
            <td>{{ d.customer_code || 'N/A' }}</td>
            <td>
              <span class="status-badge" [class.active]="d.is_active" [class.inactive]="!d.is_active">
                {{ d.is_active ? 'Active' : 'Inactive' }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="pagination" *ngIf="pagination.totalPages > 1 && !loading">
      <button class="page-btn" [disabled]="!pagination.hasPrev" (click)="goToPage(pagination.page - 1)">
        <i class="fas fa-chevron-left"></i>
      </button>
      <span class="page-info">Page {{ pagination.page }} of {{ pagination.totalPages }}</span>
      <button class="page-btn" [disabled]="!pagination.hasNext" (click)="goToPage(pagination.page + 1)">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>
</div>
  `,
  styles: [`
.modal-backdrop {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.4); backdrop-filter: blur(4px); z-index: 1000;
}
.modal {
  position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);
  background: white; border-radius: 12px; width: 800px; max-width: 95vw;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15); z-index: 1001;
  display: flex; flex-direction: column; max-height: 90vh;
}
.modal-header {
  padding: 20px 24px; border-bottom: 1px solid #e2e8f0;
  display: flex; justify-content: space-between; align-items: center;
}
.modal-header h2 { margin: 0; font-size: 1.25rem; font-weight: 600; color: #1e293b; }
.icon-btn { cursor: pointer; color: #64748b; font-size: 1.2rem; }
.icon-btn:hover { color: #0f172a; }
.modal-body { padding: 24px; overflow-y: auto; display: flex; flex-direction: column; gap: 16px; }

.search-wrap { display: flex; gap: 10px; }
.search-wrap input {
  flex-grow: 1; padding: 10px 16px; border: 1px solid #cbd5e1; border-radius: 8px;
  font-size: 0.95rem; outline: none; transition: border-color 0.2s;
}
.search-wrap input:focus { border-color: #0d9488; }

.btn { padding: 8px 16px; border-radius: 6px; cursor: pointer; font-weight: 500; font-size: 0.9rem; transition: background 0.2s; }
.btn.secondary { background: white; border: 1px solid #cbd5e1; color: #475569; }
.btn.secondary:hover { background: #f8fafc; }

.state-msg { text-align: center; color: #64748b; padding: 30px; font-size: 0.95rem; }
.error-msg { background: #fee2e2; color: #dc2626; padding: 12px; border-radius: 6px; font-size: 0.9rem; text-align: center; }

.table-container { overflow-x: auto; border: 1px solid #e2e8f0; border-radius: 8px; }
.data-table { width: 100%; border-collapse: collapse; text-align: left; }
.data-table th { background: #f8fafc; padding: 12px 16px; font-size: 0.8rem; font-weight: 600; color: #64748b; text-transform: uppercase; border-bottom: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0;}
.data-table th:last-child { border-right: none;}
.data-table td { padding: 14px 16px; border-bottom: 1px solid #e2e8f0; color: #334155; font-size: 0.9rem; border-right: 1px solid #e2e8f0;}
.data-table td:last-child { border-right: none;}
.data-table tbody tr:last-child td { border-bottom: none; }
.data-table tbody tr:hover { background: #f1f5f9; }

.pagination {
  display: flex; align-items: center; justify-content: center; gap: 16px; padding-top: 10px;
}
.page-btn {
  background: white; border: 1px solid #cbd5e1; border-radius: 6px;
  width: 32px; height: 32px; display: flex; align-items: center; justify-content: center;
  cursor: pointer; color: #475569; transition: all 0.2s;
}
.page-btn:hover:not(:disabled) { background: #f8fafc; border-color: #94a3b8; color: #0f172a; }
.page-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.page-info { font-size: 0.9rem; color: #64748b; }

.status-badge { padding: 4px 8px; border-radius: 12px; font-size: 0.75rem; font-weight: 600; }
.status-badge.active { background: #ecfdf5; color: #059669; border: 1px solid #a7f3d0; }
.status-badge.inactive { background: #fef2f2; color: #dc2626; border: 1px solid #fecaca; }
  `]
})
export class LinkedDistributorsModalComponent implements OnInit {
  @Input() retailerId: string = '';
  @Input() retailerName: string = '';
  @Output() close = new EventEmitter<void>();

  distributors: any[] = [];
  pagination = { total: 0, page: 1, limit: 10, totalPages: 1, hasNext: false, hasPrev: false };
  searchTerm = '';
  loading = false;
  errorMsg = '';

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.fetchDistributors(1);
  }

  fetchDistributors(page: number) {
    this.loading = true;
    this.errorMsg = '';
    
    let url = `${environment.apiBaseUrl}/admin/retailer/${this.retailerId}/distributors?page=${page}&limit=${this.pagination.limit}`;
    if (this.searchTerm && this.searchTerm.trim().length > 0) {
      url += `&search=${encodeURIComponent(this.searchTerm.trim())}`;
    }

    this.http.get<any>(url).subscribe({
      next: (res) => {
        this.loading = false;
        if (res.statusCode === 200 && res.data) {
          // The backend getRetailerDistributorsService returns assignments without pagination.
          // Wait, doesn't it return just an array of assignments?
          // Let's assume it returns an array.
          if (Array.isArray(res.data)) {
            this.distributors = res.data;
            // mock pagination since we don't have it on this specific endpoint
            this.pagination = { total: res.data.length, page: 1, limit: res.data.length, totalPages: 1, hasNext: false, hasPrev: false };
          } else if (res.data.distributors) {
            this.distributors = res.data.distributors || [];
            this.pagination = res.data.pagination;
          }
        } else {
          this.errorMsg = res.message || 'Failed to fetch linked distributors';
        }
      },
      error: (err) => {
        this.loading = false;
        this.errorMsg = err?.error?.message || 'Failed to fetch linked distributors';
      }
    });
  }

  onSearch() {
    // Note: If backend doesn't support search on assignments natively, this may just re-fetch.
    this.fetchDistributors(1);
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.pagination.totalPages) {
      this.fetchDistributors(page);
    }
  }

  onClose() {
    this.close.emit();
  }
}
